import getHtmlParam from '../../utilities/htmlParam';
import * as traversal from '../../utilities/traversal';
import { domReady } from '../../utilities/domready';
import { windowLoaded } from '../../utilities/domready';
import { scrollToElement } from '../../utilities/scroll';
import { toCart } from './tocart';
import { updateInc } from './helper';
import { fadeIn, fadeOut } from '../../utilities/helpers';

export class Variants {
    private mp: Map<any, any>;
    private param: Map<any, any>;
    private listExpanded: Boolean;

    private expandVariants() {
        windowLoaded(() => {
            let maxItems: number = 6;
            let container = document.querySelectorAll('.pda-variant-table')[0];
            let emptyMessage = document.querySelectorAll('.variant-filter-empty')[0];
            let variants = document.querySelectorAll('.pda-variant-table .product-list-row');
            let innerHeight = (<HTMLElement>container).offsetHeight;
            let visibleVariants: number = 0;
            let variantHeight = 50;

            let moreToggle = container.querySelectorAll('.toggle-more')[0];
            if(typeof moreToggle !== 'undefined') {
                moreToggle.parentNode.removeChild(moreToggle);
            }

            if(typeof variants !== 'undefined') {
                variants.forEach((item: HTMLElement) => {
                    if(!item.classList.contains('hidden')) {
                        variantHeight = item.clientHeight;
                        visibleVariants = visibleVariants + 1;
                    }
                });
            }

            if(typeof variants[0] !== 'undefined') {
                let maxHeight = maxItems * variantHeight + 40;
                if(visibleVariants > maxItems) {
                    container.classList.add('_hasMore');
                    container.setAttribute("style", "height: "+maxHeight+"px;");
                    container.insertAdjacentHTML('beforeend', '<div class="toggle-more"><span>'+this.mp.get('show_more')+'</span></div>');

                    domReady(() => {
                        let moreToggle = container.querySelectorAll('.toggle-more')[0];
                        moreToggle.addEventListener('click', () => {
                            let container = traversal.parents(moreToggle, '.pda-variant-table')[0];

                            if(container.classList.contains('_hasMore')) {
                                container.classList.remove('_hasMore');
                                container.classList.add('_hasLess');
                                container.setAttribute("style", "height: auto;");
                                moreToggle.innerHTML = '<span>' + this.mp.get('show_less') + '</span>';
                                moreToggle.classList.add('toggle-more-close');
                                this.listExpanded = true;
                            } else {
                                container.classList.add('_hasMore');
                                container.classList.remove('_hasLess');
                                container.setAttribute("style", "height: "+maxHeight+"px;");
                                moreToggle.innerHTML = '<span>' + this.mp.get('show_more') + '</span>';
                                moreToggle.classList.remove('toggle-more-close');
                                this.listExpanded = false;
                                window.scrollTo(window.scrollX, window.scrollY - innerHeight);
                            }
                        });

                        if(this.listExpanded == true) {
                            container.classList.remove('_hasMore');
                            container.classList.add('_hasLess');
                            container.setAttribute("style", "height: auto;");
                            moreToggle.innerHTML = '<span>' + this.mp.get('show_less') + '</span>';
                            moreToggle.classList.add('toggle-more-close');
                        }
                    });
                } else {
                    container.classList.remove('_hasMore');
                    container.classList.remove('_hasLess');
                    container.setAttribute("style", "height: auto;");
                }
            }

            if(visibleVariants == 0) {
                emptyMessage.classList.remove('hidden');
            } else {
                emptyMessage.classList.add('hidden');
            }
        });
    }


    scrollToVariants() {
        let scrollToVariants = document.querySelectorAll('.toggle-variants');

        if(typeof scrollToVariants !== 'undefined') {
            scrollToVariants.forEach((item: HTMLElement) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    let scrollConfig = new Map();
                    scrollConfig.set('element', '#product-variant');
                    scrollConfig.set('offsetElement', '.head');
                    scrollConfig.set('fixedAfterScroll', '.head');
                    scrollConfig.set('fixedSwitchManual', 20);
                    scrollToElement(scrollConfig);
                });
            });
        }
    }


    loadVariant() {
        windowLoaded(() => {
            let self = this;


            self.expandVariants();
            self.initVariantIncrementer();
            const tocart = new toCart();
            tocart.initVariants();

            // scaled price toggle
            const toggleScaledprices = document.querySelectorAll('.toggle-scaledprices');
            toggleScaledprices.forEach(price => {
                price.addEventListener('click', () => {
                    if (price.classList.contains('active')) {
                        price.classList.remove('active');
                        fadeOut(price.querySelector('.variant-scaled-wrapper'));
                    } else {
                        price.classList.add('active');
                        fadeIn(price.querySelector('.variant-scaled-wrapper'));
                    }
                });
            });
        });
    }

    loadFilter() {
        const selectBox = Array.from(document.querySelectorAll('.pda-variant-filter select'));
        const resetButton = document.querySelector('.pda-variant-filter .variant-filter-reset');

        if(typeof selectBox !== 'undefined') {
            selectBox.forEach(select => {
                select.addEventListener('change', () => {
                    this.applyFilter();
                });
            })
        }

        resetButton && resetButton.addEventListener('click', () => {
            this.resetFilter();
        });
    }

    applyFilter() {
        let variants = document.querySelectorAll('.pda-variant-table .product-list-row');
        let filterSelect = document.querySelectorAll('.pda-variant-filter-select');

        if(typeof variants !== 'undefined') {
            variants.forEach((variant: Element) => {
                variant.classList.remove('hidden');
            });
        }

        if(typeof filterSelect !== 'undefined') {
            filterSelect.forEach((select: HTMLSelectElement) => {
                let featureId = select.getAttribute('data-feature-id');
                let featureValue = select.value;
                let index: number = 0;

                if(typeof variants !== 'undefined') {
                    variants.forEach((variant: Element) => {
                        let variantFeatureValue = variant.getAttribute('data-'+featureId);
                        if(featureValue != '') {
                            if(featureValue != variantFeatureValue) {
                                variant.classList.add('hidden');
                            }
                        }

                        index++;
                    });
                }
            });
        }

        this.expandVariants();
    }

    resetFilter() {
        let variants = document.querySelectorAll('.pda-variant-table .product-list-row');
        let filterSelect = document.querySelectorAll('.pda-variant-filter-select');

        if(typeof variants !== 'undefined') {
            variants.forEach((variant: Element) => {
                variant.classList.remove('hidden');
            });
        }

        if(typeof filterSelect !== 'undefined') {
            filterSelect.forEach((select: HTMLSelectElement) => {
                select.selectedIndex = 0;
            });
        }

        this.expandVariants();
    }


    initVariantIncrementer() {
        let self = this;

        const incrementerButtons = document.querySelectorAll('.variant-incrementer');
        if(typeof incrementerButtons !== 'undefined') {
            incrementerButtons.forEach((button: HTMLElement) => {
                button.addEventListener('click', () => {

                    const input = button.closest('.variant-form-field-incremeter').querySelector('.basket-quantity') as HTMLInputElement;
                    const currentValue: number = parseInt(input.value);
                    let newVal: number = 1;

                    if (button.textContent.trim() === "+") {
                        newVal = currentValue + 1;
                        button.closest('.variant-form-field-incremeter').querySelector('.incrementer-dec').classList.remove('incrementer-inactive');
                    } else {
                        // Don't allow decrementing below 1
                        if (currentValue > 1) {
                            newVal = currentValue - 1;
                        } else {
                            newVal = 1;
                        }
                        if (newVal <= 1) button.classList.add('incrementer-inactive');
                        if (newVal > 1) button.classList.remove('incrementer-inactive');
                    }

                    input.value = newVal.toString();

                    self.updateVariantScaledPrice(newVal, button);
                });
            });
        }
    }

    updateVariantScaledPrice(newVal: number, button: Element) {
        const parent = traversal.parents(button, '.product-list-row')[0];
        const scaledPrices = parent.querySelectorAll('.variant-scaled-row');

        if(typeof scaledPrices !== 'undefined') {
            if (scaledPrices.length > 0) {
                scaledPrices.forEach((price: HTMLElement) => {
                    let quantity: number = parseInt(price.getAttribute('data-scaled-quantity'));
                    let scaledPrice = price.getAttribute('data-scaled-price');

                    if (newVal >= quantity) {
                        let priceField = parent.querySelectorAll('.variant-price')[0];
                        priceField.innerHTML = scaledPrice;
                    }
                });
            }
        }
    }

    init() {
        windowLoaded(() => {
            const container = document.querySelectorAll('.pda-variant-list')[0];

            // container only exist if variant exist
            if (typeof container !== 'undefined') {
                this.mp = getHtmlParam('.js-mp .param');
                this.param = getHtmlParam('.js-param .param');
                this.listExpanded = false;

                this.scrollToVariants();
                this.loadVariant();
                this.loadFilter();
            }
        });
    }
}